import Input from './Input';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';

type CopyInputProps = {
    value: string;
    name: string;
};

export default function CopyInput({ value, name }: CopyInputProps) {
    return (
        <Input
            name={name}
            value={value}
            trailingAddon={
                <div
                    data-testid="copy-input-copy-icon"
                    className="alli-cursor-pointer"
                    onClick={() => navigator.clipboard.writeText(value)}>
                    <DocumentDuplicateIcon
                        className="alli-h-5 alli-w-5"
                        aria-hidden="true"
                    />
                </div>
            }
        />
    );
}
